import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=d3513c52&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=d3513c52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3513c52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3513c52')) {
      api.createRecord('d3513c52', component.options)
    } else {
      api.reload('d3513c52', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=d3513c52&scoped=true&", function () {
      api.rerender('d3513c52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KHYc7o3F7gYz/JS/teamMember.vue"
export default component.exports